import React from 'react'
import Nav from './Nav'
import Header from './Header'
import { Translation } from 'react-i18next'
import i18n from '../../languages/lang.js'

const Loading = props => {
  if (props.mode === 'clear') {
    return (
      <Translation>
        {
          (t) => (
            <div id="main">
              <div id="content-wrap">
                <div id='loading'>{t('system.loading')}</div>
              </div>
            </div>
          )
        }
      </Translation>
    )
  }
  return (
    <Translation>
      {
        (t) => (
          <div id="main">
            <Nav selected={props.selected} currentUser={props.currentUser} />
            <div id="content">
              <Header />
              <div id="content-wrap">
                <div id='loading'>{t('system.loading')}</div>
              </div>
            </div>
          </div>
        )
      }
    </Translation>
  )
}

export default Loading
